import {
  TextAlignLeft01Icon,
  Attachment01Icon,
  AiChat02Icon,
  Image01Icon,
  Video01Icon,
  VoiceIcon,
  MusicNote01Icon,
  Eraser01Icon,
  ZoomInAreaIcon,
  VideoReplayIcon,
  // New nodes
  InputNumericIcon,
  ToggleOnIcon,
  ImageUploadIcon,
  ThirdBracketIcon,
  TextAlignLeftIcon,
  HeadphonesIcon,
  ChartBarLineIcon,
  ArrowDataTransferHorizontalIcon,
  ImageCropIcon,
  Resize02Icon,
  TextCheckIcon,
  // Control nodes
  CheckmarkCircle01Icon,
  // Agent nodes
  AiBrain01Icon,
  // Compositor
  Layers01Icon,
} from "@hugeicons/core-free-icons"
import type { IconSvgElement } from "@hugeicons/react"

export const MODULE_ICONS: Record<string, IconSvgElement> = {
  // Existing
  TextAlignLeft01Icon,
  Attachment01Icon,
  AiChat02Icon,
  Image01Icon,
  Video01Icon,
  VoiceIcon,
  MusicNote01Icon,
  Eraser01Icon,
  ZoomInAreaIcon,
  VideoReplayIcon,
  // New input nodes
  InputNumericIcon,
  ToggleOnIcon,
  ImageUploadIcon,
  ThirdBracketIcon,
  // New output nodes
  TextAlignLeftIcon,
  HeadphonesIcon,
  ChartBarLineIcon,
  // New transform nodes
  ArrowDataTransferHorizontalIcon,
  ImageCropIcon,
  Resize02Icon,
  TextCheckIcon,
  // Control nodes
  CheckmarkCircle01Icon,
  // Agent nodes
  AiBrain01Icon,
  // Compositor
  Layers01Icon,
}
